import { render, staticRenderFns } from "./FTransition.vue?vue&type=template&id=037f2b82&"
import script from "./FTransition.vue?vue&type=script&lang=js&"
export * from "./FTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports